Librarian.SearchOptions = new Class({
    Extends: MUI.Panel,

    Binds: [
        "loadSearchOptions", "fetchSearchOptions", "fetchDefaultSearchOptions", "onSubmit",
        "onInputChanged", "buildQuery", "search", "renderFilters", "resetFilters", "doSearchTerm",
        "onLoaded", "renderBucketFilter"
    ],

    Implements: Options,

    options: {
        id: "searchOptionsPanel",
        resizable: false,
        width: 260,
        sourceName: Librarian.elasticSearch.sourceName
    },


    className: "search-options",
    searchOptions: null,
    loaded: false,
    filtersLoaded: false,
    bucketsLoaded: false,
    searchFileAttributesLoaded: false,
    searchOptionsLoaded: false,

    template: Handlebars.compile("\
        <div class='{{class}}'> \
            <div class='{{class}}-search-input-cont'> \
                <div class='{{class}}-search-input-wrapper'> \
                    <input type='search' class='{{class}}-search-input' placeholder='Search Library' aria-label='library search query' /> \
                    <button aria-label='execute search' type='button' class='{{class}}-search-input-ico ico-search'></button> \
                </div> \
                <form class='{{class}}-elastic-operator'>\
                    <span class='{{class}}-search-operator-label'>Search Logic:</span> \
                    <input aria-label='or operator' type='radio' id='{{class}}-elastic-operator-or' name='elasticOperator' value='or' checked> \
                    <label for='{{class}}-elastic-operator-or'>OR</label> \
                    <input aria-label='and operator' type='radio' id='{{class}}-elastic-operator-and' name='elasticOperator' value='and'> \
                    <label for='{{class}}-elastic-operator-and'>AND</label> \
                </form>\
            </div> \
            <form class='{{class}}-form'> \
                <div class='{{class}}-reset'>Reset Filters</div> \
                <div class='{{class}}-filters'></div> \
            </form> \
        </div> \
    "),

    formEl: null,
    filterEls: [],

    initialize: function(options) {
        var self = this;
        this.setOptions(options);

        this.parent(this.options);

        this.hide();

        this.addEvent("filtersLoaded", function () {
            self.filtersLoaded = true;
            self.onLoaded();
        });
        this.addEvent("bucketsLoaded", function () {
            self.bucketsLoaded = true;
            self.onLoaded();
        });
        this.addEvent("aggregatesLoaded", self.onAggregatesLoaded);

        Librarian.ElasticSearch.loadSearchPreference();

        //this.fetchDefaultSearchOptions();
        this.fetchSearchOptions();
        this.fetchSearchFileAttributes();
        this.fetchSearchSlideAttributes();
        this.fetchSearchGroupAttributes();
    },

    onLoaded: function() {
        if (this.filtersLoaded && this.bucketsLoaded) {
            var value = this.contentTypeFilter.inputClass.get()[0];
            var queryContentType = value.queryContentType;
            this.toggleAttributeFilters(queryContentType);

            this.loaded = true;
            this.fireEvent("loaded");
        }
    },

    onAggregatesLoaded: function () {
        var self = this;

        Array.each(self.aggregates, function(aggregate) {
            Array.each(self.filters, function(filter) {
                if (!filter.options.exclude && ((filter.options.attributeName === aggregate.name) || (filter.options.name === aggregate.name))) {
                    filter.fireEvent("renderAggregates", aggregate);
                }
            });
        });
    },

    onOptionsLoaded: function () {
        var self = this;
        if (this.searchOptionsLoaded && this.searchFileAttributesLoaded
            && this.searchGroupAttributesLoaded && this.searchSlideAttributesLoaded) {
            var filters = [];

            Array.each(this.searchOptions.filters, function (filter) {
                if (filter.attributeName == "searchAttributes") {
                    if (Librarian.elasticSearch.attributeFilters) {
                        var attributeFilters = [];

                        if (filter.name == "fileAttributes") {
                            attributeFilters = self.searchFileAttributes;
                        } else if (filter.name == "groupAttributes") {
                            attributeFilters = self.searchGroupAttributes;
                        } else if (filter.name == "slideAttributes") {
                            attributeFilters = self.searchSlideAttributes;
                        }

                        attributeFilters = attributeFilters.map(function (option) {
                            return Object.merge({}, filter, option);
                        });
                        filters = filters.concat(attributeFilters);
                    }
                } else {
                    filters.push(filter);
                }
            });

            this.searchOptions.filters = filters;

            this.render();
        }
    },

    isDefaultSearchOption: function () {
        return this.sourceName === this.options.sourceName;
    },

    loadSearchOptions: function (json) {
        this.resetOptions();

        this.searchOptions = JSON.parse(json.trim());
        Librarian.SearchOptions.searchOptions = this.searchOptions;
        this.searchOptionsLoaded = true;
        this.onOptionsLoaded();
    },

    fetchSearchOptions: function (sourceName) {
        this.sourceName = sourceName = sourceName || this.options.sourceName;
        var self = this;
        Librarian.Utils.getSlideText({ filename: sourceName }, function (searchOptions) {
            self.loadSearchOptions(searchOptions.Text.replace("ï»¿", ""));
        }, null, this.fetchDefaultSearchOptions);
    },

    fetchDefaultSearchOptions: function () {
        var self = this;

        var getSearchOptionsJson = new Request({
            method: "get",
            url: Librarian.path.getLayoutsPath() + "core/search/searchoptions.json",
            onSuccess: function (searchOptions) {
                self.loadSearchOptions(searchOptions);
            }
        });

        getSearchOptionsJson.send();
    },

    fetchSearchFileAttributes: function () {
        var self = this;

        var request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getfatl") + "&all=0&includeValues=true&out=cjson",
            onFailure: Librarian.Utils.onFailure,
            onSuccess: function (attributes) {
                self.fileAttributes = attributes;
                attributes = attributes.filter(function (attribute) {
                    return attribute.searchable;
                });

                var attributeFilters = attributes.map(function (attribute) {
                    return {
                        "name": "fileAttributes",
                        "label": attribute.name,
                        "attributeName": attribute.name,
                        "attributeDef": attribute
                    }
                });
                self.searchFileAttributes = attributeFilters;
                self.searchFileAttributesLoaded = true;
                self.onOptionsLoaded();
            }.bind(this)
        });
        request.send();
    },

    fetchSearchGroupAttributes: function () {
        var self = this;

        var request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getgatl") + "&all=0&includeValues=true&out=cjson",
            onFailure: Librarian.Utils.onFailure,
            onSuccess: function (attributes) {
                self.groupAttributes = attributes;
                attributes = attributes.filter(function (attribute) {
                    return attribute.searchable;
                });

                var attributeFilters = attributes.map(function (attribute) {
                    return {
                        "name": "fileAttributes",
                        "label": attribute.name,
                        "attributeName": attribute.name,
                        "attributeDef": attribute
                    }
                });
                self.searchGroupAttributes = attributeFilters;
                self.searchGroupAttributesLoaded = true;
                self.onOptionsLoaded();
            }.bind(this)
        });
        request.send();
    },

    fetchSearchSlideAttributes: function () {
        var self = this;

        var request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getsatl") + "&all=0&includeValues=true&out=cjson",
            onFailure: Librarian.Utils.onFailure,
            onSuccess: function (attributes) {
                self.slideAttributes = attributes;
                attributes = attributes.filter(function (attribute) {
                    return attribute.searchable;
                });

                var attributeFilters = attributes.map(function (attribute) {
                    return {
                        "name": "slideAttributes",
                        "label": attribute.name,
                        "attributeName": attribute.name,
                        "attributeDef": attribute
                    }
                });
                self.searchSlideAttributes = attributeFilters;
                self.searchSlideAttributesLoaded = true;
                self.onOptionsLoaded();
            }.bind(this)
        });
        request.send();

    },

    render: function () {
        var self = this;
        var contEl = this.contentEl;

        contEl.empty();
        contEl.set("html", this.template({
            "class": this.className
        }));

        var searchEl = contEl.getElement("." + this.className + "-search-input-ico");
        searchEl.addEvent("click", function (e) {
            self.search();
        });

        var searchBoxEl = this.contentEl.getElement("." + this.className + "-search-input");
        Librarian.ElasticSearch.Autocomplete.createAutoCompleteElement(searchBoxEl);
        searchBoxEl.addEvent("keyup", function (e) {
            if (e.key == "enter") {
                self.search();
            }
        });

        var resetEl = contEl.getElement("." + this.className + "-reset");
        resetEl.addEvent("click", this.resetFilters);

        this.elasticOperatorEl = contEl.getElement("." + this.className + "-elastic-operator");

        var defaulOperator = Librarian.ElasticSearch.searchPreference.elasticOperator || Librarian.elasticSearch.defaultOperator;
        if (defaulOperator != null) {
            if (defaulOperator == "and") {
                var andEl = contEl.getElement("#" + this.className + "-elastic-operator-and");
                andEl.setAttribute("checked", true);
            }
            else if (defaulOperator == "or") {
                var orEl = contEl.getElement("#" + this.className + "-elastic-operator-or");
                orEl.setAttribute("checked", true);              
            }
        }

        var operatorOptionsEl = this.elasticOperatorEl.getElements("input[type=radio][name=elasticOperator");
        operatorOptionsEl.addEvent("change", function (e) {
            var operator = self.elasticOperatorEl.toQueryString().parseQueryString();
            Librarian.ElasticSearch.setSearchPreference(operator);
            self.search();
        });

        this.renderFilters();
        this.renderBucketFilter();
    },

    reset: function () {
        var searchBox = this.contentEl.getElement("." + this.className + "-search-input");
        searchBox.set("value", "");

        this.resetFilters(false);
    },

    resetOptions: function () {
        this.loaded = false;
        this.filtersLoaded = false;
        this.bucketsLoaded = false;
    },

    resetFilters: function (doSearchAfter) {
        if (doSearchAfter == undefined) {
            doSearchAfter = true;
        }

        this.resetOptions();
        this.renderFilters();
        this.renderBucketFilter();

        if (doSearchAfter) {
            this.search();
        }
    },

    renderFilters: function () {
        var self = this;
        var contEl = this.contentEl;
        var filterOptions = this.searchOptions.filters;
        var filterEl = contEl.getElement("." + this.className + "-filters");

        this.filters = [];
        filterEl.empty();
        var filtersToLoad = filterOptions.length;

        var onFilterLoaded = function () {
            filtersToLoad--;

            if (filtersToLoad == 0) {
                self.fireEvent("filtersLoaded");
            }
        }

        Array.each(filterOptions, function (filter, index) {
            filter.class = self.className;
            filter.id = self.className + "-" + filter.name + "-" + (new Date()).getTime() + "-" + index;

            var contEl = filterEl;

            var filterObj;
            if (filter.name == "searchTerms") {
                filter.fileAttributes = self.fileAttributes;
                filter.slideAttributes = self.slideAttributes;
                filterObj = new Librarian.SearchOptions.Terms(filter);
                self.terms = filterObj;
            } else {
                filterObj = new Librarian.SearchOptions.Filter(filter, self);
                self.filters.push(filterObj);

                if (filter.name == "contentTypes") {
                    self.contentTypeFilter = filterObj;
                }
            }

            var inputEl = filterObj.contEl;
            filterObj.addEvent("change", self.onInputChanged);

            if (filterObj.loaded) {
                onFilterLoaded();
            } else {
                filterObj.addEvent("load", onFilterLoaded);
            }

            contEl.grab(inputEl);
        });
    },

    renderBucketFilter: function () {
        var self = this;
        if (Librarian.SearchOptions.searchOptions != null && Librarian.SearchOptions.searchOptions.groups != null) {
            var bucketFiltersEl = $("search-result-category-filter");
            if (bucketFiltersEl) {
                bucketFiltersEl.empty();

                var inputEl = new Element("div", {
                    "class": this.className + "-category-filters"
                });

                var options = Librarian.SearchOptions.searchOptions.groups.map(function (group) {
                    return {
                        "name": group.label,
                        "value": group.label,
                        "selected": group.selected
                    }
                });

                var filter = {
                    "name": "searchBucket",
                    "options": options,
                    "optionType": "radio",
                    "class": this.className,
                    "id": this.className + "-bucket",
                    "container": inputEl
                };

                var filterObj = this.bucketFilter = new Librarian.SearchOptions.OptionsFilter(filter);
                filterObj.addEvent("change", this.onInputChanged);
                filterObj.addEvent("load", function () {
                    self.fireEvent("bucketsLoaded");
                });

                inputEl.grab(filterObj.render());
                bucketFiltersEl.grab(inputEl);
            } else {
                this.addEvent("searchPageLoaded", this.renderBucketFilter);
            }
        } else {
            this.fireEvent("bucketsLoaded");
        }
    },

    buildQuery: function (searchOptions, extraFilters) {
        var value = this.getSearchTerm();

        searchOptions.searchTerms = new Librarian.ElasticSearch.ElasticSearchQuerySearchTerms();
        searchOptions.filters = new Librarian.ElasticSearch.ElasticSearchQueryFilter();
        searchOptions.exclusionFilters = new Librarian.ElasticSearch.ElasticSearchQueryFilter();

        var options = this.parseSearchQuery(value);
        value = options.term;
        var libraryFilters = Librarian.elasticSearch.filters;

        searchOptions.searchTerms.query = value;
        // Get Search Terms
        if (this.terms != null) {
            this.terms.get(searchOptions.searchTerms, value, options);
        }

        // Get Filters
        if (this.filters != null) {
            Array.each(this.filters, function (filter) {
                filter.get(searchOptions);
            });
        }

        Object.each(libraryFilters, function (value, key) {
            searchOptions.filters.set(key, value, true);
        });

        Object.each(extraFilters, function (value, key) {
            searchOptions.filters.set(key, value, true);
        });
    },

    getSearchTerm: function () {
        var searchBox = this.contentEl.getElement("." + this.className + "-search-input");

        return searchBox.get("value").trim();
    },

    onInputChanged: function (filter) {
        if (filter.options != null && filter.options.name == "contentTypes") {
            var value = filter.inputClass.get()[0];
            var queryContentType = value.queryContentType;

            this.toggleAttributeFilters(queryContentType);
        }

        this.search();
    },

    toggleAttributeFilters: function (queryContentType) {
        var enabledFilters = [];
        var attribFilters = ["fileAttributes", "slideAttributes"];

        Array.each(this.filters, function (filter) {
            if (attribFilters.contains(filter.options.name) && filter.options.hasOwnProperty("queryContentType")) {
                if (((filter.options.queryContentType & queryContentType) !== 0) && !enabledFilters.contains(filter.options.attributeName)) {
                    enabledFilters.push(filter.options.attributeName);
                    filter.enable();
                } else {
                    filter.disable();
                }
            }
        });
    },

    parseSearchQuery: function (searchTerm) {
        var options = {
            term: searchTerm
        };

        var elasticOperator = this.elasticOperatorEl.toQueryString().parseQueryString();
        if (elasticOperator["elasticOperator"] == "and") {
            options.operator = elasticOperator["elasticOperator"];
        }   

            /*
        else {
            var andRegex = /(?:(and|or) )*(\w+)/gmi;
            var match, previousMatch;

            var ands = [];
            var ors = [];

            while ((match = andRegex.exec(searchTerm)) != null) {
                var operator = match[1].toLowerCase();
                var wordTerm = match[2];

                if (operator == "and") {
                
                }
                else if (operator == "or") {

                } else {
                
                }

                previousMatch = match;

            }
        }*/

        return options;

    },

    isGroupedResults: function () {
        if (this.bucketFilter == null) {
            return false;

        }

        var selectedBuckets = this.bucketFilter.get();

        return selectedBuckets.contains(Librarian.elasticSearch.allGroupsFilterName);
    },

    search: function (extraFilters) {
        var self = this;
        if (this.loaded) {
            var value = this.getSearchTerm();

            if ((value || "").trim().length > 0) {
                var currentHash = Librarian.Utils.getHash().parseQueryString() || {};
                if (!currentHash.hasOwnProperty("page")) {
                    currentHash.page = "search";
                }
                currentHash["q"] = encodeURIComponent(value);
                var hashString = (new Hash(currentHash).toQueryString());
                Librarian.Utils.changeHash(hashString);
            }

            // Suggestions and search
            var doSuggest = Librarian.SearchOptions.searchOptions.suggester != null
                && Librarian.SearchOptions.searchOptions.suggester.enabled;
            var requestCount = doSuggest ? 1 : 0;
            var groupResults = [];
            var searchResults = null;
            var suggestions = null;
            var currentSearchOptions = null;
            var onComplete = function (results, group, searchOptions, suggestionResult) {
                if (group != null) {
                    groupResults[group.index].results = results;
                    groupResults[group.index].searchOptions = searchOptions;
                }

                if (results != null) {
                    searchResults = results;
                }

                if (suggestionResult != null) {
                    suggestions = suggestionResult;
                }

                if (searchOptions != null) {
                    currentSearchOptions = searchOptions;
                }

                requestCount--;

                if (requestCount === 0) {
                    var searchResult = groupResults.length > 1 ? groupResults : searchResults;
                    Librarian.SearchResult.prepSearchPage(searchResult, currentSearchOptions, suggestions);
                    if (Librarian.elasticSearch.aggregates && searchResults.aggregations)
                        self.aggregates = searchResults.aggregations;
                        self.fireEvent("aggregatesLoaded");
                }

            }

            var suggestionEs = function (text) {
                var es = new Librarian.ElasticSearch.Suggest({
                    loadComplete: function (results) {
                        onComplete(null, null, this.searchOptions, results);
                    }
                });

                es.suggest(text, Librarian.SearchOptions.searchOptions.suggester);
            };

            var isGroupedResults = this.isGroupedResults();
            var searchEs = function (group) {
                var es = new Librarian.ElasticSearch({
                    loadComplete: function (results) {
                        onComplete(results, group, this.searchOptions);
                    },
                    beforeLoadComplete: function () {
                        // Load the search tab
                        Library.loadTabByName("search") || Library.loadTabByName("advancedsearch");
                    },
                    elasticSearchQueryOptions: {
                        size: isGroupedResults ? Librarian.SearchResult.groupResultCount : Librarian.search.maxResults
                    }
                });

                self.buildQuery(es.searchOptions, extraFilters);

                var continueSearch = true;
                if (group != null) {
                    if (Library.customGroupSearchFilter != null) {
                        continueSearch = Library.customGroupSearchFilter(es.searchOptions, group);
                    } else {
                        Librarian.SearchOptions.Filter.buildFilter(es.searchOptions, { type: "custom" }, group.customFilter);
                    }
                }

                Librarian.search.lastQuery = es.searchOptions;

                if (continueSearch) {
                    es.search();
                }
                else {
                    onComplete(null, group, es.searchOptions);
                }
       
            }

            if (Librarian.SearchOptions.searchOptions.groups != null) {
                var selectedBuckets = this.bucketFilter.get();
                var buckets = Librarian.SearchOptions.searchOptions.groups;
                var selectAll = selectedBuckets.contains(Librarian.elasticSearch.allGroupsFilterName);

                if (selectedBuckets.length > 0) {
                    buckets = Librarian.SearchOptions.searchOptions.groups.filter(function (group) {
                        if (selectAll) {
                            if (group.label != Librarian.elasticSearch.allGroupsFilterName && !Librarian.elasticSearch.excludeGroupsFilter.contains(group.label)) {
                                return true;
                            }
                        } else {
                            if (selectedBuckets.contains(group.label)) {
                                return true;
                            }
                        }          
                    });
                }
                requestCount += buckets.length;
                Array.each(buckets, function (group, index) {
                    group.index = index;
                    groupResults.push(group);

                    searchEs(group);
                });
            } else {
                requestCount += 1;
                searchEs();
            }

            // Get suggestions
            if (doSuggest) {
                suggestionEs(value);
            }
        } else {
            this.addEvent("loaded:once", function () {
                self.search();
            });
        }    
    },


    loadSelectedCategoryName: function() {
        // IM HERE JUST FOR COMPATABILITY. I DO NOTHING.
    },

    closeCatSelectWindow: function() {
        // IM HERE JUST FOR COMPATABILITY. I DO NOTHING.
    },

    doSearchTerm: function (searchTerm, filters) {
        var self = this;

        if (this.loaded) {
            var searchBox = this.contentEl.getElement("." + this.className + "-search-input");
            searchBox.set("value", searchTerm);

            this.search(filters);
        } else {
            this.addEvent("loaded:once", function() {
                self.doSearchTerm(searchTerm, filters);
            });
        }
    },

    useLastSearchOptions: function() {
        if (Librarian.search.lastQuery != null) {
            var searchBox = this.contentEl.getElement("." + this.className + "-search-input");
            searchBox.set("value", Librarian.search.lastQuery.searchTerm);
        }
    },

    hide: function() {
        this.parent();

        var searchPageEl = $("search-result-page");
        if (searchPageEl) {
            searchPageEl.hide();
        }
    },

    set: function(name, value) {

    }
});


Librarian.SearchOptions.Filter = new Class({
    Implements: [Options, Events],
    Binds: ["onInputChanged", "onLoadAttributeDef", "render", "get"],

    options: {
        label: "",
        name: "",
        displayed: "",
        "default": "",
        accordion: true,
        startOpen: false,
        attributeName: "",
        container: null,
        exclude: false
    },

    className: "search-options-filter",
    value: {},
    loaded: false,

    template: Handlebars.compile("\
        <div class='{{class}}'> \
            <div class='{{class}}-header'> \
                <label class='{{class}}-header-label'>{{label}}</label> \
                <span class='{{class}}-count'></span> \
            </div> \
            <div class='{{class}}-body'></div> \
        </div>"),

    initialize: function(options, parent) {
        this.setOptions(options);
        this.parent = parent;

        var cleanLabel = this.options.label;
        if (cleanLabel) {
            cleanLabel = cleanLabel.replaceAll(" ", "_");
        }
        else {
            cleanLabel = this.options.name.replaceAll(" ", "_");
        }

        this.options.id = this.options.id || this.className + "-" + this.options.name + "-cont-" + (new Date().getTime()) + cleanLabel;

        this.initContainer();
        this.load();

        this.addEvent("renderAggregates", this.renderAggregates);
    },

    load: function() {
        if (this.options.attributeName.length > 0) {
            this.loadAttributeDef();
        }
        else if (this.options.name === "fileTypes") {
            this.loadFileTypes();
        }
        else if (this.options.name === "contentTypes") {
            this.loadContentTypes();
        }
        else if (this.options.name === "fileSubTypes") {
            this.loadContentTypes();
        }
        else {
            this.render();
        }
    },

    initContainer: function () {
        if (this.options.container != null) {
            this.contEl = this.options.container;
            this.bodyEl = this.contEl;

            this.contEl.empty();
        } else {
            if (this.contEl == null) {                    
                this.contEl = new Element("div", {
                    "class": this.className + "-cont", 
                    "id": this.options.id
                    });
            } else {
                this.contEl.empty();
            }

            var html = this.template({
                "class": this.className,
                "label": this.options.label
            });

            this.contEl.set("html", html);
            this.headerEl = this.contEl.getElement("." + this.className + "-header");
            this.bodyEl = this.contEl.getElement("." + this.className + "-body");
            this.countEl = this.contEl.getElement("." + this.className + "-count");

            if (this.options.accordion !== false) {
                this.accordion = new Librarian.Accordion(this.headerEl, this.bodyEl, { startOpen: this.options.startOpen });
            }
        }
    },

    render: function () {
        var self = this;
        var filter = this.options;
        this.inputClass = null;

        if (filter.tree) {
            switch (filter.treeType) {
            case "categorizedAttribute":
                this.inputClass = new Librarian.SearchOptions.CategorizedAttributeTreeFilter(filter);
                break;
            case "categories":
                this.inputClass = new Librarian.SearchOptions.CategoryTreeFilter(filter);
                break;
            }
        } else if (filter.options) {
            this.inputClass = new Librarian.SearchOptions.OptionsFilter(filter);

        } else if (filter.type == "date") {
            this.inputClass = new Librarian.SearchOptions.DateFilter(filter);
        } else {
            this.inputClass = new Librarian.SearchOptions.TextFilter(filter);
        }

        if (this.inputClass != null) {
            this.inputClass.addEvent("load", function () {
                self.loaded = true;
                self.fireEvent("load");
            });

            var inputEl = this.inputClass.render();
            this.inputClass.addEvent("change", this.onInputChanged);
            this.bodyEl.grab(inputEl);

            if (filter.displayed === false) {
                this.contEl.hide();
            }
        }

        return this.inputClass;
    },

    onInputChanged: function() {
        this.fireEvent("change", this);
    },

    get: function (searchOption) {
        if (this.options.disabled) {
            return;
        }

        var value = this.inputClass.get();

        Librarian.SearchOptions.Filter.buildFilter(searchOption, this.options, value, this.options.exclude);
    },

    renderAggregates: function (aggregate) {
        this.updateCount(aggregate);
        this.inputClass.fireEvent("aggregateCount", aggregate);
    },

    updateCount: function (aggregate) {
        if (this.countEl) {
            var count = "(" + aggregate.total + ")";
            if (aggregate.total > 10000) {
                count = "(10k+)";
            }
            this.countEl.set("text", aggregate.total > 0 ? count : "");
        }
    },

    set: function(value) {
        this.inputClass.set(value);
    },

    reset: function() {
        this.inputClass.reset();
        this.onInputChanged();
    },

    destroy: function() {
        this.inputClass.destroy();
    },

    disable: function() {
        this.options.displayed = false;
        this.options.disabled = true;

        this.contEl.hide();
    },

    enable: function() {
        this.options.displayed = true;
        this.options.disabled = false;

        this.contEl.show();
    },

    loadAttributeDef: function() {
        var filter = this.options;

        if (filter.attributeDef != null) {
            this.onLoadAttributeDef(filter.attributeDef);
        } 
        else {
            var getAttributeDefinition = new Librarian.Request.JSON({
                method: "get",
                url: Librarian.path.getMethodUrl("getat") + "&out=cjson&atname=" + filter.attributeName,
                onSuccess: this.onLoadAttributeDef
            });

            getAttributeDefinition.send();
        }
    },

    onLoadAttributeDef: function(attribDef) {
        if (!attribDef)
            attribDef = {};

        var filter = this.options;

        filter.attributeDef = attribDef;
        if (attribDef.dropdown) {
            if (!Librarian.admin.dynamicDropdownAttributes.contains(this.options.label)) {
                filter.options = attribDef.dropdownValues.map(function (option) {
                    return {
                        "name": option.value,
                        "value": option.value
                    }
                });
            }
        } else if (attribDef.categorized) {
            filter.tree = true;
            filter.treeType = "categorizedAttribute";
        }
        else if (attribDef.dataType == Librarian.attributeDataType.datetime) {
            filter.type = "date";
            filter.isRange = true;

        }
        else {
            if (attribDef.dataType == Librarian.attributeDataType.bool) {
                filter.isMultiValued = true;
                filter.options = [
                    {
                        "name": "All",
                        "value": "",
                        "selected": true
                    },
                    {
                        "name": "True",
                        "value": "true,True"
                    },
                    {
                        "name": "False",
                        "value": "false,False"
                    }
                ];
                filter.optionType = "radio";
            }
        }

        this.render();
    },

    loadContentTypes: function () {
        var self = this;
        var filter = this.options;

        filter.options = filter.options.map(function(option) {
            var type = Librarian.SearchOptions.Filter.typeFilters[option];
            type.name = Librarian.Lang.getString(type.name);
            type.value = option;

            return type;
        });

        this.render();
    },

    loadFileTypes: function () {
        var self = this;

        Librarian.Utils.getFileTypes(function (fileTypes) {
            var options = fileTypes.map(function (fileType) {
                return {
                    "name": fileType.FileTypeExtension,
                    "value": fileType.FileTypeId
                }
            });

            filter.options = options;

            self.render();
        });
    },

    loadFileSubTypes: function() {
        var options = [];

        Object.each(Librarian.subType, function (value, key) {
            options.push({
                "name": key,
                "value": value
            });
        });

        filter.options = options;
        this.render();
    }
})
.extend({
    buildFilter: function (searchOption, filter, value, exclude) {
        var self = this;
        value = filter.value || value;

        if ((typeOf(value) == "array" || typeOf(value) == "string") && value.length == 0) {
            return;
        }

        var inclusionFilterOption = searchOption.filters;
        var exclusionFilterOption = searchOption.exclusionFilters;
        var filterOption = exclude ? exclusionFilterOption : inclusionFilterOption;

        if (filter.type == "custom") {
            var values = Array.from(value);

            Array.each(values, function (value) {
                var customFilters = value.filters;
                var customExclusionFilters = value.exclusionFilters;
                var queryContentType = value.queryContentType;

                if (customFilters != null) {
                    Object.each(customFilters, function (customFilter, key) {
                        filterOption.set(key, customFilter);
                    });
                }

                if (customExclusionFilters != null) {
                    Object.each(customExclusionFilters, function (customFilter, key) {
                        exclusionFilterOption.set(key, customFilter);
                    });
                }

                if (queryContentType != null) {
                    searchOption.queryContentType = queryContentType;
                }
            });
        }
        else if (filter.attributeName != null && filter.attributeName.trim().length > 0) {
             var attribVal = {};

             //Temporary fix to ensure dynamic dropdown queries are not case sensitive
             if (Librarian.admin.dynamicDropdownAttributes.contains(filter.attributeName)) {
                 if (typeOf(value) == "array") {
                     var formattedValues = [];
                     Array.each(value, function (item) {
                         item = item.capitalize();
                         item = item.trim();
                         formattedValues.push(item);
                     });
                     attribVal[filter.attributeName] = formattedValues;
                 } else {
                     attribVal[filter.attributeName] = value.substr(0, 1).toUpperCase() + value.substr(1);
                 }
             } 
             else if (filter.treeType == "categorizedAttribute") {
                attribVal[filter.attributeName] = {
                    isCategorized: true,
                    catIds: value
                }
             }
             else {
                 attribVal[filter.attributeName] = value;
             }

             filterOption.set(filter.name, attribVal);
        } else {
             filterOption.set(filter.name, value);
        }
    },

    typeFilters: {
        "all": {
            name: "view_bar_all",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file | Librarian.ElasticSearch.queryContentType.group,
            }
        },
        "presentations": {
            name: "view_bar_presentations",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file,
                filters: {
                    fileSubTypes: [Librarian.subType.presentation]
                }
            }
        },
        "slides": {
            name: "view_bar_slides",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.slide,
                filters: {
                    fileSubTypes: [Librarian.subType.presentation],
                    parentContentType: Librarian.ElasticSearch.queryContentType.file
                }
            }
        },
        "groups": {
            name: "view_bar_groups",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.group
            }
        },
        "groupSlides": {
            name: "view_bar_group_slides",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.slide,
                filters: {
                    parentContentType: Librarian.ElasticSearch.queryContentType.group
                }
            }
        },
        "documents": {
            name: "view_bar_documents",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file,
                filters: {
                    fileSubTypes: [Librarian.subType.document]
                }
            }
        },
        "pages": {
            name: "view_bar_pages",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.slide,
                filters: {
                    fileSubTypes: [Librarian.subType.document],
                    parentContentType: Librarian.ElasticSearch.queryContentType.file
                }
            }
        },
        "media": {
            name: "view_bar_media",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file,
                filters: {
                    fileSubTypes: [Librarian.subType.media, Librarian.subType.image, Librarian.subType.movie, Librarian.subType.sound]
                }
            }
        },
        "images": {
            name: "view_bar_images",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file,
                filters: {
                    fileSubTypes: [Librarian.subType.image]
                }
            }
        },
        "movies": {
            name: "view_bar_movies",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file,
                filters: {
                    fileSubTypes: [Librarian.subType.movie]
                }
            }
        },
        "audio": {
            name: "view_bar_audio",
            customFilter: {
                queryContentType: Librarian.ElasticSearch.queryContentType.file,
                filters: {
                    fileSubTypes: [Librarian.subType.sound]
                }
            }
        }
    }
});

Librarian.SearchOptions.Terms = new Class({
    Extends: Librarian.SearchOptions.Filter,
    
    render: function () {
        var self = this;
        var filter = this.options;
        var fileAttributes = filter.fileAttributes || [];
        var slideAttributes = filter.slideAttributes || [];


        var termContext = [];
        var options = [];
        Array.each(Librarian.SearchOptions.searchOptions.terms, function (term) {
            if (!termContext.contains(term.context)) {
                var level2Options = [];

                if (term.context == "fileAttributes") {
                    if (term.attributes != null) {
                        level2Options = term.attributes.map(function (attribute) {
                            attribute.value = "fileAttributes";
                            attribute.name = attribute.attributeName;

                            return attribute;
                        });
                    } else {
                        level2Options = fileAttributes.map(function (attribute) {
                            var additionalInfo = (term.overrides || {})[attribute.name];
                            return Object.merge({
                                "name": attribute.name,
                                "value": "fileAttributes",
                                "attributeName": attribute.name,
                                "selected": true
                            }, additionalInfo);
                        });
                    }
                }

                if (term.context == "slideAttributes") {
                    if (term.attributes != null) {
                        level2Options = term.attributes.map(function(attribute) {
                            attribute.value = "slideAttributes";
                            attribute.name = attribute.attributeName;

                            return attribute;
                        });
                    } else {
                        level2Options = slideAttributes.map(function (attribute) {
                            var additionalInfo = term.overrides || {};
                            return Object.merge({
                                "name": attribute.name,
                                "value": "slideAttributes",
                                "attributeName": attribute.name,
                                "selected": true
                            }, additionalInfo);
                        });
                    }

                }

                options.push({
                    "name": term.label,
                    "value": term.context,
                    "selected": term.selected,
                    "displayed": term.displayed,
                    "level2Options": level2Options
                });
            }

            termContext.push(term.context);
        });
        filter.options = options;

        this.inputClass = new Librarian.SearchOptions.OptionsFilter(filter);
        this.inputClass.addEvent("change", this.onInputChanged);
        this.inputClass.addEvent("load", function () {
            self.loaded = true;
            self.fireEvent("load");
        });


        var inputEl = this.inputClass.render();
        this.bodyEl.grab(inputEl);
    },

    get: function (searchOptions, value, options) {
        options = options || {};
        var selectedEls = this.inputClass.inputEl.getElements("input:checked");
        var values = {};
        var self = this;

        selectedEls.each(function (selectedEl) {
            if (selectedEl.get("disabled")) {
                return;
            }

            var optionInfo = selectedEl.retrieve("optionInfo");
            var inputValue = selectedEl.get("value").trim();

            if (values[inputValue] == null) {
                values[inputValue] = [];
            }

            values[inputValue].push(optionInfo);
        });

        Array.each(Librarian.SearchOptions.searchOptions.terms, function (term) {
            if (values.hasOwnProperty(term.context)) {
                Array.each(values[term.context], function (termInfo) {
                    term = Object.merge({}, term, termInfo);

                    var queryType = Librarian.ElasticSearch.searchQueryType[term.queryType];

                    var isWrappedinQuotes = /^"(.+)"$/;
                    var searchTerm = isWrappedinQuotes.exec(value);
                    var termValue = value;

                    if (searchTerm != null) {
                        if (term.queryType === "queryString") {
                            termValue = self.getQuotedTerm(termValue);
                            options.term = termValue;
                        }
                        else {
                            termValue = searchTerm[1];
                            options.term = searchTerm[1];
                            options.exactPhrase = true;
                        }
                    }

                    if (options.exactPhrase) {
                        if (queryType !== Librarian.ElasticSearch.searchQueryType.term) {
                            queryType = Librarian.ElasticSearch.searchQueryType.matchPhrase; 

                            if (term.hasOwnProperty("slop")) {
                                delete term.slop;
                            }

                            if (Librarian.elasticSearch.allowMatchPhraseStopWords) {
                                term.analyzer = "standard";
                            }
                        }
                    }

                    if (["fileAttributes", "slideAttributes"].contains(term.context)) {
                        if ((term.attributeName || "").trim().length === 0) {
                            return;
                        }

                        termValue = {};
                        termValue[term.attributeName] = value;
                    }

                    if (options.exactPhrase == true && term.analyzer == "word_delimiter_with_stemming")
                        term.analyzer = "word_delimiter";

                    if (options.operator) {
                        term.operator = options.operator;
                    }

                    searchOptions.set(term.context, termValue, queryType, term);
                });
            }
        });
    },

    getQuotedTerm: function (searchTerm) {
        var quoteRegEx = /(".*?")/gm;

        return searchTerm.replace(quoteRegEx, "+$1");
    }
});


Librarian.SearchOptions.OptionsFilter = new Class({
    Implements: [Options, Events],
    Binds: ["onInputChanged", "renderOptions"],

    options: {
        label: "",
        name: "",
        displayed: "",
        "default": "",
        accordion: true,
        startOpen: false,
        attributeName: "",
        optionType: "checkbox",
        level2Options: null
    },

    className: "search-options-input",

    template: Handlebars.compile("\
        <input id='{{id}}-input' type='{{type}}' name='{{name}}' value='{{value}}' {{#if selected}}checked{{/if}} {{#if disabled}}disabled{{/if}} \> \
        <label for='{{id}}-input'>{{label}}</label> \
        <span id='{{id}}-count' class='{{countClass}}'></span>"),

    initialize: function (options) {
        this.setOptions(options);

        this.addEvent("aggregateCount", this.aggregateCount);
    },

    aggregateCount: function (aggregate) {
        var self = this;
        var filter = this.options;

        if (aggregate.name !== filter.attributeName && aggregate.name !== filter.name)
            return;

        this.resetCount();

        Array.each(aggregate.buckets, function(bucket) {
            var option = filter.options.find(function (option, index) {
                return option.name.toLowerCase() == bucket.key.toLowerCase();
            });
            if (option) {
                option.count = bucket.value;
                self.updateCount(option);
            }
        });
    },

    render: function () {
        var filter = this.options;
        var self = this;
        var options = filter.options;
        var contEl = this.inputEl = new Element("div", {
            "class": this.className + filter.optionType
        });

        Array.each(options, function (option, index) {
            var optionEl = self.renderOptions(filter, option, index);

            if (option.level2Options != null && option.level2Options.length > 0) {
                var triggerEl = new Element("span", {
                    "class": self.className + "-level2-trigger"
                });
                var levelOptionEl = new Element("div", {
                    "class": self.className + filter.optionType + " nested-option"
                });

                Array.each(option.level2Options, function (level2Option, index) {
                    if (!option.selected) {
                        level2Option.disabled = true;
                    }

                    var optionEl = self.renderOptions(filter, level2Option, index);
                    levelOptionEl.grab(optionEl);
                });

                optionEl.getElement("input").addEvent("change", function () {
                    var level2OptionsEl = levelOptionEl.getElements("input");
                    if (!this.get("checked")) {
                        level2OptionsEl.set("disabled", true);
                    } else {
                        level2OptionsEl.set("disabled", false);
                    }
                });

                optionEl.grab(triggerEl);
                optionEl.grab(levelOptionEl);

                new Librarian.Accordion(triggerEl, levelOptionEl, { startOpen: false });
            }

            if (option.displayed === false)
                optionEl.hide();

            filter.options[index].id = optionEl.id;
            contEl.grab(optionEl);
        });

        var inputEls = contEl.getElements("input,select,textarea");
        inputEls.addEvent("change", this.onInputChanged);

        this.fireEvent("load");

        return contEl;
    },

    renderOptions: function (filter, option, index) {
        var isSelected = option.selected,
            id = option.id || this.className + "-" + filter.name + "-" + (new Date().getTime()) + "-" + index,
            optionValue = option.value == undefined ? option.name : option.value;

        if (option.selected == null && filter.default === optionValue) {
            isSelected = true;
        }

        var html = this.template({
            "id": id,
            "name": filter.name,
            "label": option.name,
            "selected": isSelected,
            "type": filter.optionType,
            "value": optionValue,
            "disabled": option.disabled,
            "countClass": this.className + "-count"
        });

        var optionEl = new Element("div", {
            "id": id,
            "class": this.className + "-" + filter.optionType + "-option",
            "html": html
        });

        var inputEl = optionEl.getElement("input");

        inputEl.store("optionInfo", option);

        return optionEl;
    },

    onInputChanged: function() {
        this.fireEvent("change", this.get());
    },

    get: function () {
        var filter = this.options;
        var selectedEls = this.inputEl.getElements("input:checked");
        var values = [];

        selectedEls.each(function (selectedEl) {
            var optionInfo = selectedEl.retrieve("optionInfo");
            var inputValue = selectedEl.get("value").trim();

            if (optionInfo.customFilter != null) {
                values.push(optionInfo.customFilter);
            } else if (inputValue.length > 0) {
                if (typeOf(inputValue) == "string" && filter.isMultiValued) {
                    values = values.concat(inputValue.split(","));
                } else {
                    values.push(inputValue);
                }
            }
        });

        return values;
    },

    updateCount: function(option) {
        var optionEl = this.inputEl.getElement('span[id=' + option.id + '-count]');
        if (optionEl) {
            var count = "(" + option.count + ")";
            if (option.count > 10000) {
                count = "(10k+)";
            }
            optionEl.set("text", option.count > 0 ? count : "");
        }
    },

    resetCount: function () {
        var filter = this.options,
            self = this,
            options = filter.options;

        Array.each(options, function(option) {
            var countEl = self.inputEl.getElement('span[id=' + option.id + '-count]');
            countEl.empty();
        });
    },

    set: function() {
        
    },

    reset: function() {
        
    }
});

Librarian.SearchOptions.TextFilter = new Class({
    Implements: [Options, Events],
    Binds: ["onInputChanged", "search"],

    options: {
        label: "",
        name: "",
        displayed: "",
        "default": "",
        accordion: true,
        startOpen: false,
        attributeName: ""
    },

    className: "search-options-input",

    template: Handlebars.compile("<input id='{{id}}-input' type='text' class='{{class}}-value' name='{{name}}' />"),

    initialize: function (options) {
        this.setOptions(options);
    },

    render: function () {
        var self = this;

        var html = this.template({
            "class": this.className,
            "name": this.options.name,
            "id": this.options.id
        });

        var contEl = new Element("div", {
            "class": this.className + "-text",
            "html": html
        });

        this.inputEl = contEl.getElement("input");

        if (this.options.default != null) {
            this.inputEl.set("value", this.options.default);
        }

        this.inputEl.addEvent("keyup", function (e) {
            if (e.key == "enter") {
                self.onInputChanged();
            }
        });

        this.fireEvent("load");

        return contEl;
    },

    onInputChanged: function () {
        this.fireEvent("change", this.get());
    },

    get: function () {  
        var value = this.inputEl.get("value");

        if (value.contains(',')) {
            const valuesArray = value.split(',');
            return valuesArray;
        } else {
            return value;
        }
    },

    set: function () {

    },

    reset: function () {

    }
});

Librarian.SearchOptions.DateFilter = new Class({
    Implements: [Options, Events],
    Binds: ["onInputChanged"],

    options: {
        label: "",
        name: "",
        displayed: "",
        "default": "",
        accordion: true,
        startOpen: false,
        attributeName: "",
        isRange: false
    },

    className: "search-options-input",

    dateTemplate: Handlebars.compile("\
            <input id='{{id}}-label' type='text' class='{{class}}-value' name='{{name}}' /> \
            <span class='pointer ico-search-date {{class}}-calendar'></span>"),

    dateRangeTemplate: Handlebars.compile("\
            <div class='{{class}}-value-field'> \
                <label for='{{id}}-label-from' class='{{class}}-value-label'>From</label> \
                <div class='{{class}}-value-cont'> \
                    <input id='{{id}}-label-from' type='text' class='{{class}}-value date-from' name='{{name}}' /> \
                    <span class='pointer ico-search-date {{class}}-calendar'></span> \
                </div> \
            </div> \
            <div class='{{class}}-value-field'> \
                <label for='{{id}}-label-to' class='{{class}}-value-label'>To</label> \
                <div class='{{class}}-value-cont'> \
                    <input aria-label='date-to' id='{{id}}-label-to' type='text' class='{{class}}-value date-to' name='{{name}}' /> \
                    <span class='pointer ico-search-date {{class}}-calendar'></span> \
                </div> \
            </div>"),

    initialize: function (options) {
        this.setOptions(options);
    },

    render: function () {
        var filter = this.options,
            self = this;

        var contEl = this.inputEl = new Element("div");

        if (filter.isRange) {
            contEl.addClass(this.className + "-date-range");
            contEl.set("html", this.dateRangeTemplate({
                "class": this.className,
                "name": filter.name,
                "id": filter.id
            }));

        } else {
            contEl.addClass(this.className + "-date");
            contEl.set("html", this.dateTemplate({
                "class": this.className,
                "name": filter.name,
                "id": filter.id
            }));
        }

        var dateInputsEl = contEl.getElements("input");
        dateInputsEl.each(function (inputEl) {
            var iconEl = inputEl.getNext("." + self.className + "-calendar");

            Librarian.Utils.setUpDatePicker2(inputEl, iconEl);
        });

        dateInputsEl.addEvent("focusout", this.onInputChanged);
        dateInputsEl.addEvent("keyup", function (e) {
            if (e.key == "enter") {
                self.onInputChanged();
            }
        });

        if (this.options.default != null) {
            //this.inputEl.set("value", this.options.default);
        }

        this.fireEvent("load");
        return contEl;
    },

    onInputChanged: function () {
        this.fireEvent("change", this.get());
    },

    get: function () {
        if (this.options.isRange) {
            var minVal = this.inputEl.getElement("input.date-from").get("value");
            var maxVal = this.inputEl.getElement("input.date-to").get("value");

            return {
                minDate: minVal,
                maxDate: maxVal
            }

        } else {
            return this.inputEl.getElement("input").get("value");
        }
    },

    set: function () {

    },

    reset: function () {

    }
});

Librarian.SearchOptions.CategorizedAttributeTreeFilter = new Class({
    Implements: [Options, Events],
    Binds: ["onInputChanged"],

    options: {
        label: "",
        name: "",
        displayed: "",
        "default": "",
        accordion: true,
        startOpen: false,
        attributeName: ""
    },

    className: "search-options-input",

    initialize: function (options) {
        this.setOptions(options);

        this.addEvent("aggregateCount", this.aggregateCount);
    },

    aggregateCount: function (aggregate) {
        this.aggregate = aggregate;
        var self = this;
        var filter = this.options;

        if (aggregate.name == filter.attributeName)
            this.recursivelySetCount();
    },

    render: function () {
        var self = this;
        var filter = this.options;
        var attribDef = filter.attributeDef;

        var contEl = new Element("div", {
            "class": this.className + "-categorized-attribute"
        });

        var catAttrTree = this.tree = new Mif.Tree({
            container: contEl,
            forest: true,
            json: [],
            types: {
                folder: {
                    openIcon: "mif-tree-open-icon",
                    closeIcon: "mif-tree-close-icon"
                }
            }
        });
        catAttrTree.initCheckbox();
        catAttrTree.addEvent("switch", function (node, checked) {
             self.recursivelySetState(node, checked);
             self.onInputChanged();
        });

        catAttrTree.addEvent("updateNode", function() {
            self.recursivelySetCount();
        });

        var getAttributeTree = new Librarian.Request.JSON({
            method: "get",
            url: Librarian.path.getMethodUrl("getatcat") + "&out=mtree&recursive=true&pcid=0&atid=" + attribDef.id,
            onFailure: Librarian.Utils.onFailure,
            onSuccess: function (data) {
                catAttrTree.load({
                    json: data
                });
                self.fireEvent("load");
            }
        });
        getAttributeTree.send();

        filter.tree = catAttrTree;

        return contEl;
    },

    recursivelySetCount: function (node) {
        var self = this,
            aggregate = self.aggregate,
            node = node || this.options.tree.root;

        var setCountEl = function (node, count) {
            var nodeWrapper = node.getDOM("wrapper");
            var countSpan = new Element("span", {
                "class": "mif-tree-node-count",
                "text": "(" + count.value + ")"
            });
            nodeWrapper.adopt(countSpan);
        };

        node.recursive(function () {
            var currNode = this;
            var nodeWrapper = currNode.getDOM("wrapper");
            var countEl = nodeWrapper.getElement(".mif-tree-node-count");

            if (countEl)
                countEl.destroy();

            if (currNode.type == "folder") {
                var obj = aggregate.buckets.find(function (bucket) {
                    return parseInt(bucket.key) == currNode.data.attribcatid;
                });
                if (obj) {
                    setCountEl(currNode, obj);
                }
            }

            if (currNode.name.length >= 1 && currNode.getChildren().length >= 1 && currNode !== node) {
                self.recursivelySetCount(currNode);
            }
        });
    },

    recursivelySetState: function (node, checked) {
        var self = this;
        node.recursive(function () {
            var state = checked ? "checked" : "unchecked";
            if (this.state.checked !== state) {
                this.setCheckboxState(checked ? "checked" : "unchecked");
            }
        });
    },

    onInputChanged: function() {
        this.fireEvent("change", this.get());
    },

    get: function() {
        var values = [];
        var checkedItems = this.tree.getChecked();

        Array.each(checkedItems, function (item) {
            values.push(item.data.attribcatid);
        });

        return values;
    }

});

Librarian.SearchOptions.CategoryTreeFilter = new Class({
    Implements: [Options, Events],

    Binds: ["onInputChanged", "onNodeChecked", "onTreeNodeLoaded"],

    options: {
        label: "",
        name: "",
        displayed: "",
        "default": "",
        accordion: true,
        startOpen: false,
        attributeName: "",
        rootCatId: 0,
        selectedCategories: null,
        catType: Librarian.catType.file,
        useCatId: false
    },

    className: "search-options-input",
    include: null,
    exclude: null,
    aggregate: null,

    initialize: function (options) {
        options.type = "custom";

        this.setOptions(options);
        this.include = [];
        this.exclude = [];

        this.addEvent("aggregateCount", this.aggregateCount);
    },

    aggregateCount: function (aggregate) {
        this.aggregate = aggregate;
        var self = this;
        var filter = this.options;

        if (aggregate.name !== filter.name)
            return;

        this.recursivelySetCount();
    },

    render: function () {
        var filter = this.options;
        var self = this;

        if (!this.contEl) {
            this.contEl = new Element("div", {
                "class": this.className + "-categories"
            });
        }
        else {
            this.contEl.empty();
        }

        var catTree = this.tree = new Librarian.TreeView({
            container: this.contEl,
            checkBoxes: true,
            hideTypes: ["file"],
            catType: this.options.catType,
            cookieStorage: false,
            method: "getcc",
            contentView: Librarian.tileList.contentViewName,
            rootCat: this.options.rootCatId
        });

        catTree.addEvent("switch", function (node, checked) {
            self.recursivelySetState(node, checked);
            self.onNodeChecked(node, checked);
            self.fireEvent("change", self.get());
        });

        catTree.addEvent("load", function () {
            self.fireEvent("load");
        });

        catTree.addEvent("loadNode", function () {
            if (self.aggregate)
                self.recursivelySetCount();
        });

        //catTree.addEvent("loadChildren", this.onTreeNodeLoaded);
        catTree.addEvent("loadChildren", function (node) {
            if (node) {
                self.recursivelySetState(node, node.state.checked == "checked");
                self.onTreeNodeLoaded(node);
            }
        });

        filter.tree = catTree;

        catTree.load();
        return this.contEl;
    },

    onTreeNodeLoaded: function (parent) {
        var self = this;
        if (!parent || (this.options.selectedCategories == null))
            return;

        var selected = this.options.selectedCategories.split(';');
        var selectedIds = this.options.selectedCategoryIds || [];

        if (selected.contains(parent.name) || selectedIds.contains(parent.data.catId)) {
            parent.setCheckboxState("checked");
            self.onNodeChecked(parent, parent.state.checked == "checked");
        }

        var children = parent.getChildren();
        for (var i = 0; i < children.length; i++) {
            if (selected.contains(children[i].name) || selectedIds.contains(children[i].data.catId)) {
                children[i].setCheckboxState("checked");
                self.onNodeChecked(children[i], children[i].state.checked == "checked");
            }
        }
    },

    onInputChanged: function () {
        this.fireEvent("change", this.get());
    },

    onNodeChecked: function (node, checked) {
        var value = this.getValue(node);

        if (checked) {
            // If deliberately unchecked before and re-added, remove from exclusion
            if (this.exclude.contains(value)) {
                this.exclude.erase(value);
            }
            // If deliberately checked add to inclusion
            else {
                this.include.push(value);
            }
        } else {
            // If deliberately checked before and removed. remove from exclusion
            if (this.include.contains(value)) {
                this.include.erase(value);
            }
            // If deliberately unchecked add to exclusion
            else {
                this.exclude.push(value);
            }
        }
    },

    recursivelySetCount: function (node) {
        var self = this,
            aggregate = self.aggregate,
            node = node || this.options.tree.root;
            
        var setCountEl = function (node, count) {
            var nodeWrapper = node.getDOM("wrapper");
            var countSpan = new Element("span", {
                "class": "mif-tree-node-count",
                "text": "(" + count.value + ")"
            });
            nodeWrapper.adopt(countSpan);
        };

        node.recursive(function () {
            var currNode = this;
            var nodeWrapper = currNode.getDOM("wrapper");
            var countEl = nodeWrapper.getElement(".mif-tree-node-count");

            if (countEl)
                countEl.destroy();

            if (currNode.type == "folder") {
                var obj = aggregate.buckets.find(function(bucket) {
                    return bucket.key == currNode.id;
                });
                if (obj) {
                    setCountEl(currNode, obj);
                }
            }

            if (currNode.id > 0 && currNode.getChildren().length >= 1 && currNode !== node && currNode.state.open) {
                self.recursivelySetCount(currNode);
            }
        });
    },

    recursivelySetState: function (node, checked) {
        var self = this;
        node.recursive(function () {
            var state = checked ? "checked" : "unchecked";
            if (this.state.checked !== state) {
                this.setCheckboxState(checked ? "checked" : "unchecked");

                // Remove since recursrively checking is just for visual flair
                var value = self.getValue(this);
                self.exclude.erase(value);
                self.include.erase(value);
            }
        });
    },

    getValue: function (item) {
        var name = this.options.name;
        // Use property name in cases when name is being modified on end user side
        if (item.property && (item.property.name != item.name))
            item.name = item.property.name;

        if (name === "categoryPaths") {
            if (this.options.useCatId) {
                if (item.data.catid > 0) {
                    return "*/" + item.data.catid + "/*";
                }
                return item.data.catid + "/*";
            } else {
                return this.tree.getPath(item) + "/*";
            }

        } else {
            return item.data.catid;
        }
    },

    get: function () {
        var name = this.options.name;
        var value = {
            filters: {},
            exclusionFilters: {}
        };

        if (this.include.length > 0) {
            value.filters[name] = this.include;
        }

        if (this.exclude.length > 0) {
            value.exclusionFilters[name] = this.exclude;
        }

        return value;
    },

    set: function () {

    }

});